module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Emb7"))).then(() => parcelRequire('fThBo'));